import React, { useState } from 'react';
import { Text, View, Pressable } from 'react-native';
import styles from './styles';

interface CounterProps {
  value: number;
  onChange: (value: number) => void;
}

const Counter = ({ value = 0, onChange }: CounterProps) => {
  const [plusHovered, setPlusHovered] = useState(false);
  const [minusHovered, setMinusHovered] = useState(false);

  const handleAdd = () => onChange(value + 1);
  const handleSubtract = () => onChange(value - 1);

  return (
    <View style={styles.counter}>
      <Pressable
        disabled={value === 0}
        onPress={handleSubtract}
        onHoverIn={() => setMinusHovered(true)}
        onHoverOut={() => setMinusHovered(false)}
        style={[styles.counterButton, minusHovered && styles.hovered]}
      >
        <Text style={styles.counterLabel} selectable={false}>
          -
        </Text>
      </Pressable>
      <Text style={styles.counterValue} selectable={false}>
        {value || 0}
      </Text>
      <Pressable
        onPress={handleAdd}
        onHoverIn={() => setPlusHovered(true)}
        onHoverOut={() => setPlusHovered(false)}
        style={[styles.counterButton, plusHovered && styles.hovered]}
      >
        <Text style={styles.counterLabel} selectable={false}>
          +
        </Text>
      </Pressable>
    </View>
  );
};

export default Counter;
